import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";

import { Provider as LoginProvider } from "./context/loginContext";
import { Provider as CustomersProvider } from "./context/customersContext";
import { Provider as SalesProvider } from "./context/salesContext";
import Routers from "./components/router/Routers";
import theme from "./styles/theme";

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <LoginProvider>
                    <CustomersProvider>
                        <SalesProvider>
                            <Routers />
                        </SalesProvider>
                    </CustomersProvider>
                </LoginProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default App;
